import { render, staticRenderFns } from "./TargetingIpAllowed.vue?vue&type=template&id=fcfb0c92&"
import script from "./TargetingIpAllowed.vue?vue&type=script&lang=js&"
export * from "./TargetingIpAllowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports